export const formatDecimalisedPercentage = (val: number) => (val * 100).toFixed(2) + '%';
export const formatPercentage = (val: number) => val.toFixed(2) + '%';
